/**
 * The unique key for a main Myle tab, matching the vocab key to display.
 */
enum MyleTabKey {
    Myle = "MYLELabel",
    Admin = "AdministrationMenuLabel",
    Calendar = "CalendarMenuLabel",
    Patients = "PatientsLabel",
    Communications = "CommunicationsLabel",
    Documents = "DocumentsLabel",
    Billing = "BillingLabel",
    Scheduling = "AffectationsLabel",
    LabResults = "LabsLabel",
    Lists = "WaitingListsLabel",
    Portfolio = "PortfolioLabel",
    Reporting = "ReportingLabel",
    Settings = "SettingsLabel",
    PrescriptionRenewals = "PrescriptionRenewalLabel",
    PharmacyOrders = "PharmacyOrders_OrdersLabel"
}

export { MyleTabKey };
